export default "__VITE_ASSET__778f90f9__"